export const LIVEBLOG_CONTENT_TYPES = [
    { value: 'event', label: 'Event', icon: 'mdi-whistle' },
    { value: 'text', label: 'Text', icon: 'mdi-text' },
    { value: 'image', label: 'Image', icon: 'mdi-image' },
    { value: 'gallery', label: 'Gallery', icon: 'mdi-image-multiple' },
    { value: 'video', label: 'Video', icon: 'mdi-video' },
    { value: 'twitter', label: 'Twitter', icon: 'mdi-twitter' },
    { value: 'link', label: 'Link', icon: 'mdi-link-variant' },
    { value: 'highlight', label: 'Highlight', icon: 'mdi-play-circle-outline' },
]

export function emptyLiveblogForm(match = null, overrides = {}) {
    return {
        content_type: 'event',
        event_id: '',
        provider_event_id: '',
        provider: '',
        title: '',
        body: '',
        payload: null,
        event_type_id: '',
        event_type_name: '',
        event_reason_id: '',
        period_id: '',
        period_name: '',
        comment: '',
        event_minute: '',
        place: '',
        team_code: '',
        team_id: '',
        player_id: '',
        player_name: '',
        related_player_id: '',
        related_player_name: '',
        event_reason_name: '',
        home_goals: match?.score_home ?? '',
        away_goals: match?.score_away ?? '',
        image_file: null,
        gallery_items: null,
        ...overrides,
    }
}

export function liveblogEntryToForm(item) {
    if (!item || !item.event_id) return null
    return {
        content_type: item.content_type || '',
        provider_event_id: item.provider_event_id || '',
        provider: item.provider || '',
        title: item.title || '',
        body: item.body || '',
        payload: item.payload || null,
        event_type_id:
            item.event_type_id != null && item.event_type_id !== '' ? String(item.event_type_id) : '',
        event_type_name: item.event_type_name || '',
        event_reason_id:
            item.event_reason_id != null && item.event_reason_id !== ''
                ? String(item.event_reason_id)
                : '',
        period_id: item.period_id != null && item.period_id !== '' ? String(item.period_id) : '',
        period_name: item.period_name || '',
        comment: item.comment || '',
        event_minute: (item.event_minute || '').replace("'", ''),
        place: item.place || '',
        team_code: item.team_code || '',
        team_id: item.team_id != null && item.team_id !== '' ? String(item.team_id) : '',
        player_id: item.player_id != null && item.player_id !== '' ? String(item.player_id) : '',
        player_name: item.player_name || '',
        related_player_id:
            item.related_player_id != null && item.related_player_id !== ''
                ? String(item.related_player_id)
                : '',
        related_player_name: item.related_player_name || '',
        event_reason_name: item.event_reason_name || '',
        home_goals: item.home_goals ?? '',
        away_goals: item.away_goals ?? '',
        image_file: null,
        gallery_items: null,
    }
}

/** Defaults for the next entry after save (entries assumed newest-first). */
export function getLiveEntryDefaults(match, entries = [], overrides = {}) {
    const latest = entries.length ? entries[0] : null
    return emptyLiveblogForm(match, {
        content_type: 'event',
        event_id: '',
        provider_event_id: '',
        home_goals: latest?.home_goals ?? match?.score_home ?? '',
        away_goals: latest?.away_goals ?? match?.score_away ?? '',
        period_id: latest?.period_id != null && latest?.period_id !== '' ? String(latest.period_id) : '',
        period_name: latest?.period_name || '',
        team_code: latest?.team_code || '',
        team_id: latest?.team_id != null && latest?.team_id !== '' ? String(latest.team_id) : '',
        place: latest?.place || '',
        event_minute: latest?.event_minute ? String(latest.event_minute).replace(/'/g, '') : '',
        ...overrides,
    })
}

export function findEventTypeByPattern(eventTypes, pattern) {
    if (!Array.isArray(eventTypes)) return null
    const re = pattern instanceof RegExp ? pattern : new RegExp(pattern, 'i')
    return eventTypes.find((et) => re.test(et.event_type_name || '')) || null
}

export { findEventTypeByCode, getEventTypeMeta } from './liveblogEventTypeMeta'
